/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { VApplication } from "../../../application";
import { GET_PRESENTATIONS, RECALL_ALL_UNUSED_INVITES } from "../graphql";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IRecallAllUnusedInvitesMethods extends IPluginMethodMap {
  recallAllUnusedInvitesProps(args: any): Promise<any>;
}

export class RecallAllUnusedInvitesService implements IAgentPlugin {
  readonly methods: IRecallAllUnusedInvitesMethods;

  constructor() {
    this.methods = {
      recallAllUnusedInvitesProps: this.recallAllUnusedInvitesProps.bind(this),
    };
  }

  async recallAllUnusedInvitesProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const presentationRes = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active"
              }
            }
          },
          fetchPolicy: "network-only",
        });

        const presentationId =
          presentationRes?.data?.getPresentations?.content[0]?.id;

        if (presentationId && is.existy(presentationId)) {
          const recallRes = await client.mutate({
            mutation: RECALL_ALL_UNUSED_INVITES,
            variables: {
              filter: {
                presentation: presentationId,
              },
            },
            fetchPolicy: "no-cache",
          });

          return recallRes?.data?.recallAllUnusedInvites?.message;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
